document.addEventListener('click', (event) => {
  const button = event.target.closest('.visual-filter__toggle');
  if (!button) return;

  const content = document.getElementById(
    button.getAttribute('aria-controls')
  );
  if (!content) return;

  const isOpening = content.hasAttribute('hidden');

  if (isOpening) {
    content.removeAttribute('hidden');
  } else {
    content.setAttribute('hidden', '');
  }

  button.setAttribute('aria-expanded', String(isOpening));

  const icon = button.querySelector('.visual-filter__icon');
  if (icon) {
    icon.classList.toggle('is-open', isOpening);
  }
});